import { render, staticRenderFns } from "./FeatureToggle.vue?vue&type=template&id=028e9f22&"
import script from "./FeatureToggle.vue?vue&type=script&lang=js&"
export * from "./FeatureToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028e9f22')) {
      api.createRecord('028e9f22', component.options)
    } else {
      api.reload('028e9f22', component.options)
    }
    module.hot.accept("./FeatureToggle.vue?vue&type=template&id=028e9f22&", function () {
      api.rerender('028e9f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/FeatureToggle.vue"
export default component.exports